import {
    FETCH_APPLICANT_ACTIONS_SUCCESS,
    FETCH_APPLICANT_ACTION_BY_ID_SUCCESS,
    APPLICANT_ACTIONS_REQUEST_LOADING,
    APPLICANT_ACTIONS_REQUEST_ERRORS
} from "api/menu/hr/applicant-actions/actions";

const initialState = {
    loading: false,
    errors: [],
    actions: [],
    selectedAction: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
        case APPLICANT_ACTIONS_REQUEST_LOADING:
            return { ...state, loading: true };
        case APPLICANT_ACTIONS_REQUEST_ERRORS:
            return { ...state, loading: false, errors: action.payload };
        case FETCH_APPLICANT_ACTIONS_SUCCESS:
            return { ...state, loading: false, actions: action.payload };
        case FETCH_APPLICANT_ACTION_BY_ID_SUCCESS:
            return { ...state, loading: false, selectedAction: action.payload };
        default:
            return state;
    }
}
